import { createContext, FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export type InternationalizationFn = (
  i18nString: string | string[],
  ns?: { ns: string },
) => string;
type II18nContext = [InternationalizationFn, any];

const i18nContext = createContext<II18nContext>([(val) => val as any, 'en']);

const Provider = i18nContext.Provider;
i18nContext.displayName = 'I18nProvider';

export const I18nProvider: FC<{
  children: any;
  defaultLang?: { [key: string]: any };
}> = ({
  defaultLang = typeof window !== 'undefined' && window.appDefaultLang,
  children,
}) => {
  const { t, i18n } = useTranslation(['inverse', 'inverse-error-code']);
  const lang = i18n.language || 'en';
  let _t = t;
  if (t('accountBaseInfo') === 'accountBaseInfo') {
    _t = function (key: string | string[]) {
      if (Array.isArray(key) || !defaultLang) {
        return key;
      }

      // 将路径按点号分割成数组
      const keys = key.split('.');
      const first = keys.shift();
      let result: any = defaultLang[first as keyof typeof defaultLang];

      // 逐级访问对象属性
      for (const key of keys) {
        if (result == null) return undefined; // 如果中间结果是null/undefined，提前返回
        result = result[key as keyof typeof defaultLang]; // 访问下一级属性
      }

      return result || key;
    };
  }

  return <Provider value={[_t, lang]}>{children}</Provider>;
};

export function useI18nContext() {
  return useContext(i18nContext);
}
